import React, { useCallback, useState } from 'react';
import styled from 'astroturf/react';

import { Grid as GridBase, GridColumn } from 'js/design_system/grid/Grid';
import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import { useScreenSize, useScrollLock } from 'js/utils/hooks';
import { useAbTest as useMobileViewToolsMenuFixAbTest } from 'js/ab_tests/tests/mobile_view_tools_menu_fix_july_2023';
import SearchBar from 'js/header/SearchBar';
import { HAMBURGER_MENU_SIZE } from 'js/header/FocusedNav/FocusedNav';
import { trackClick } from 'js/utils/trackClick';

import AccountMenu from './AccountMenu';
import AccountMenuButton from './AccountMenuButton';
import SmallAccountMenuButton from './SmallAccountMenuButton';
import { HomeButton, LibraryButton, UploadButton } from './nav_buttons';
import _NavPosition from "CoreXNav-NavPosition.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=NavPosition";
import _NavContainer from "CoreXNav-NavContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=NavContainer";
import _MobileNavContainer from "CoreXNav-MobileNavContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=MobileNavContainer";
import _SearchBarContainer from "CoreXNav-SearchBarContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=SearchBarContainer";
import _MobileSearchContainer from "CoreXNav-MobileSearchContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=MobileSearchContainer";
import _WidthContainer from "CoreXNav-WidthContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=WidthContainer";
import _WidthContainerLeft from "CoreXNav-WidthContainerLeft.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=WidthContainerLeft";
import _WidthContainerRight from "CoreXNav-WidthContainerRight.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=WidthContainerRight";
import _AcademiaIcon from "CoreXNav-AcademiaIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=AcademiaIcon";
import _IconAnchorsContainer from "CoreXNav-IconAnchorsContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=IconAnchorsContainer";
import _Grid from "CoreXNav-Grid.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=Grid";
import _FullViewMenu from "CoreXNav-FullViewMenu.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=FullViewMenu";
import _BottomMenu from "CoreXNav-BottomMenu.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/CoreXNav.tsx?styleId=BottomMenu";


const NavPosition = /*#__PURE__*/styled("div", null, {
  displayName: "NavPosition",
  styles: _NavPosition
});

const NavContainer = /*#__PURE__*/styled("div", null, {
  displayName: "NavContainer",
  styles: _NavContainer
});

const MobileNavContainer = /*#__PURE__*/styled(NavContainer, null, {
  displayName: "MobileNavContainer",
  styles: _MobileNavContainer
});

const SearchBarContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SearchBarContainer",
  styles: _SearchBarContainer
});

const MobileSearchContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MobileSearchContainer",
  styles: _MobileSearchContainer
});

const WidthContainer = /*#__PURE__*/styled("div", null, {
  displayName: "WidthContainer",
  styles: _WidthContainer
});

const WidthContainerLeft = /*#__PURE__*/styled("div", null, {
  displayName: "WidthContainerLeft",
  styles: _WidthContainerLeft
});

const WidthContainerRight = /*#__PURE__*/styled("div", null, {
  displayName: "WidthContainerRight",
  styles: _WidthContainerRight
});

const AcademiaIcon = /*#__PURE__*/styled("a", null, {
  displayName: "AcademiaIcon",
  styles: _AcademiaIcon
});

const IconAnchorsContainer = /*#__PURE__*/styled("div", null, {
  displayName: "IconAnchorsContainer",
  styles: _IconAnchorsContainer
});

const Grid = /*#__PURE__*/styled(GridBase, null, {
  displayName: "Grid",
  styles: _Grid
});

const FullViewMenu = /*#__PURE__*/styled("div", null, {
  displayName: "FullViewMenu",
  styles: _FullViewMenu
});

const BottomMenu = /*#__PURE__*/styled("div", null, {
  displayName: "BottomMenu",
  styles: _BottomMenu
});

const Container = (props: { children: React.ReactNode }) => (
  <Grid
    stretchSmall={true}
    stretchMedium={true}
    stretchLarge={true}
    overridePadding={true}
  >
    <GridColumn sm={6} md={6} lg={12}>
      <WidthContainer>{props.children}</WidthContainer>
    </GridColumn>
  </Grid>
);

// NOTE: technically, funding and conferences are modals and not menus.
// But we want to keep only one of these open at any given time so yeah
// the modals are a menu now.
type Menu = 'account';

type Props = {
  inDevStyle?: boolean;
  initialQuery?: string;
  hasUnseenClaimablePapers: boolean;
  hasUnseenUploadableStubs: boolean;
};

const CoreXNav = ({
  inDevStyle,
  initialQuery,
  hasUnseenClaimablePapers,
  hasUnseenUploadableStubs,
}: Props) => {
  const [openMenu, setOpenMenu] = useState<null | Menu>(null);
  const { screenWidth } = useScreenSize();
  const isMobileNav = screenWidth < HAMBURGER_MENU_SIZE;
  useScrollLock(isMobileNav && openMenu !== null);

  const searchBar = (
    <SearchBar
      initialQuery={initialQuery}
      darkMode={false}
      focusForced={false}
      inAnswersCohort={false}
      showPremiumUpsells={false}
    />
  );

  const positionOfFullViewMenu = useMobileViewToolsMenuFixAbTest();

  const onLibraryButtonClick = useCallback(() => {
    trackClick({
      source: 'nav-bar--library-button',
    });
  }, []);

  const onUploadButtonClick = useCallback(() => {
    trackClick({
      source: 'nav-bar--upload-button',
    });
  }, []);

  if (isMobileNav) {
    return (
      <NavPosition>
        <MobileNavContainer inDevStyle={inDevStyle}>
          <Container>
            <MobileSearchContainer>{searchBar}</MobileSearchContainer>
            <SmallAccountMenuButton
              menuOpen={openMenu === 'account'}
              setMenuOpen={(open) => setOpenMenu(open ? 'account' : null)}
            />
          </Container>
        </MobileNavContainer>
        {openMenu === 'account' && (
          <FullViewMenu
            isPositionFixed={positionOfFullViewMenu === 'fixed_position'}
          >
            <AccountMenu />
          </FullViewMenu>
        )}
        <BottomMenu>
          <HomeButton />
          <LibraryButton onClick={onLibraryButtonClick} />
        </BottomMenu>
      </NavPosition>
    );
  }

  return (
    <NavPosition>
      <NavContainer inDevStyle={inDevStyle}>
        <Container>
          <WidthContainerLeft>
            <AcademiaIcon href={routes.home_url()}>
              <img src={$image_url('academia-logo-2021.svg')} />
            </AcademiaIcon>
            <SearchBarContainer>{searchBar}</SearchBarContainer>
          </WidthContainerLeft>
          <WidthContainerRight>
            <IconAnchorsContainer>
              <LibraryButton onClick={onLibraryButtonClick} />
              <UploadButton
                onClick={onUploadButtonClick}
                hasUnseenClaimablePapers={hasUnseenClaimablePapers}
                hasUnseenUploadableStubs={hasUnseenUploadableStubs}
              />
            </IconAnchorsContainer>
            <AccountMenuButton
              open={openMenu === 'account'}
              setOpen={(open) => setOpenMenu(open ? 'account' : null)}
            />
          </WidthContainerRight>
        </Container>
      </NavContainer>
    </NavPosition>
  );
};

export default CoreXNav;
